// External Dependencies:
import React, { Component } from 'react'
import GoogleAnalytics from 'react-ga'

GoogleAnalytics.initialize( {
	trackingId: siteData.google_analytics_id,
	debug: true,
	gaOptions: {
		cookieDomain: 'none'
	}
} )

const GAPageTracker = ( WrappedComponent, options = {} ) => {
	const trackPage = page => {
		if ( 'production' === process.env.NODE_ENV ) {
			GoogleAnalytics.set({
				page,
				...options
			})
			GoogleAnalytics.pageview( page )
		}
	}

	const HOC = class extends Component {
		componentDidMount() {
			const page = this.props.location.pathname
			trackPage( page )
		}

		componentWillReceiveProps( nextProps ) {
			const currentPage = this.props.location.pathname
			const nextPage = nextProps.location.pathname

			if ( currentPage !== nextPage ) {
				trackPage( nextPage )
			}
		}

		render() {
			return <WrappedComponent { ...this.props } />
		}
	}

	return HOC
}

export default GAPageTracker
